var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSucess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 221,
    viewBox: "0 0 220 221",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.49999C0 3.634 3.13401 0.5 7 0.5H213C216.866 0.5 220 3.63401 220 7.5V213.5C220 217.366 216.866 220.5 213 220.5H6.99999C3.134 220.5 0 217.366 0 213.5V7.49999Z",
    fill: "#0792E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M157.5 63.5L180 81.17L99.2177 159L48 121.427L70.5 99L99.2177 121.427L157.5 63.5Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSucess);
export default __webpack_public_path__ + "static/media/sucess.c5a0781eca2f175347ab976b4c0f6f84.svg";
export { ForwardRef as ReactComponent };